export default __webpack_public_path__ + "8e29484a27c1667a0e4bd09b90b42e92.wav";